/* CANFOTO V67BS-R6 / NEW / Shadow-only / no DOM, score, FP or rank writes */
(function(W){'use strict';
var VERSION='CANFOTO-NORA-PANEL-REAL-CAPACITY-AUDIT-V67BS-R6';
var KEYS=Object.freeze([
 'product_ecommerce::small_product_tabletop',
 'interview_talking_head::single_interview',
 'interview_talking_head::two_person_interview',
 'clinic_aesthetic_dental::dental_support',
 'rgb_creative_video::background_color_effect'
]);
var LANES=Object.freeze(['BARE_LIGHT','SINGLE_READY_SET']);
function object(v){return v && typeof v==='object'?v:{};}
function number(v){if(v===null||v===undefined||v==='')return null;var n=Number(v);return Number.isFinite(n)&&n>=0?n:null;}
function whiteSource(row,product){
 // Only explicitly labelled effective-white source fields qualify. Nominal W is NOT a substitute.
 var probes=[
  ['row.effectiveWhitePowerW',object(row).effectiveWhitePowerW],
  ['row.technical.effectiveWhitePowerW',object(row.technical).effectiveWhitePowerW],
  ['row.capabilities.effectiveWhitePowerW',object(row.capabilities).effectiveWhitePowerW],
  ['product.effectiveWhitePowerW',object(product).effectiveWhitePowerW],
  ['product.technical.effectiveWhitePowerW',object(product.technical).effectiveWhitePowerW],
  ['product.capabilities.effectiveWhitePowerW',object(product.capabilities).effectiveWhitePowerW]
 ];
 for(var i=0;i<probes.length;i++){var n=number(probes[i][1]);if(n!==null)return {watts:n,source:probes[i][0]};}
 return {watts:null,source:null};
}
function productFor(handle){var state=object(object(W.GDX_PANEL_LED_V4).state), list=Array.isArray(state.products)?state.products:[];
 return list.find(function(p){return String(p.handle||p.key||'')===handle;})||null;
}
async function audit(input){
 var opts=object(input),p=W.GDX_PANEL_V4_R2D_EXACT_SELECTION_SCORE_PROJECTION,b=W.CANFOTO_NORA_PANEL_MAIN_KEY_SHADOW_V67BS_R5;
 if(typeof p?.getRowsAsync!=='function')throw Error('HOLD_CANONICAL_ASYNC_API_MISSING');
 if(typeof b?.assess!=='function')throw Error('HOLD_R5_BAND_API_MISSING');
 var keys=Array.isArray(opts.keys)&&opts.keys.length?opts.keys:KEYS;
 var lanes=Array.isArray(opts.lanes)&&opts.lanes.length?opts.lanes:LANES;
 var records=[],parity=true;
 for(var k=0;k<keys.length;k++)for(var l=0;l<lanes.length;l++){
  var key=String(keys[k]),lane=String(lanes[l]);
  var rows=await p.getRowsAsync(key,{lane:lane,limit:0});
  var sourceRows=p.getRows(key,{lane:lane,limit:0});
  if(JSON.stringify(rows)!==JSON.stringify(sourceRows))parity=false;
  records.push({selectionKey:key,lane:lane,count:rows.length,items:rows.map(function(row,i){
   var handle=String(row.handle||p.rowHandle?.(row)||'');var product=productFor(handle);var v=whiteSource(row,product);
   var assessment=b.assess(key,{effectiveWhitePowerW:v.watts});
   return {rank:i+1,handle:handle,purchaseLane:String(row.purchaseLane||lane),effectiveWhitePowerW:v.watts,
    whitePowerSource:v.source,capacityScreen:assessment.capacityScreen,bandKey:assessment.bandKey,
    minimumCandidateW:assessment.minimumCandidateW??null,idealCandidateW:assessment.idealCandidateW??null,
    photometricFitness:assessment.photometricFitness,sourceMissing:v.watts===null};
  })});
 }
 var items=records.flatMap(function(r){return r.items;});
 var output={version:VERSION,mode:'READ_ONLY_SHADOW',canonicalAsyncSyncEqual:parity,
  selectionCount:keys.length,laneCount:lanes.length,totalRows:items.length,
  withExplicitEffectiveWhiteW:items.filter(function(x){return !x.sourceMissing;}).length,
  missingEffectiveWhiteW:items.filter(function(x){return x.sourceMissing;}).length,
  photometryCertifiedCount:0,records:records,
  scoreMutation:false,rankMutation:false,fpCurveMutation:false,
  status:parity?'PASS_READ_ONLY_AUDIT':'HOLD_ASYNC_SYNC_PARITY'};
 return output;
}
W.CANFOTO_NORA_PANEL_REAL_CAPACITY_AUDIT_V67BS_R6=Object.freeze({version:VERSION,audit:audit,
 scoreMutation:false,rankMutation:false,fpCurveMutation:false,selectionKeys:KEYS,lanes:LANES});
})(window);
